export var UserType;
(function (UserType) {
    UserType["INTERNER_ANTRAGSERSTELLER"] = "I";
    UserType["EXTERNER_ANTRAGSERSTELLER"] = "E";
    UserType["KUNDE"] = "K";
    UserType["KUNDE2"] = "KD";
    UserType["KUNDENBETREUER"] = "KB";
    UserType["ANTRAGSVERARBEITER"] = "AV";
    UserType["UNDERWRITER"] = "UW";
    UserType["ANGESTELLTER_AUSZENDIENST_VERTRIEB"] = "AAV";
    UserType["VERKAUSLEITER"] = "VL";
    UserType["MAKLERBETREUER_UND_MITARBEITER_IM_MAKLERSERVICE"] = "MBMIM";
    UserType["MITARBEITER_IM_KUNDENSERVICE"] = "MIK";
    UserType["MAKLER"] = "MAK";
    UserType["AGENT"] = "AG";
    UserType["AGENT_ZURICH_CONNECT"] = "AZC";
    UserType["VERTRAGSBEARBEITER"] = "VB";
})(UserType || (UserType = {}));
export function isZC(userType) {
    if (!userType)
        throw new Error('no userType set!');
    if (userType === UserType.KUNDE || userType === UserType.KUNDENBETREUER)
        return true;
    return false;
}
export function isHBM(userType) {
    if (!userType)
        throw new Error('no userType set!');
    return !isZC(userType);
}
